<template>
  <div class="c-topics-pager" :class="modifier">
    <ul class="c-topics-pager__inner">
      <li class="c-topics-pager__item">
        <a :href="prev" class="c-topics-pager__link" :class="{'-active': prev}">
          <e-icon name="triangle-left"></e-icon>
          <span>PREV</span>
        </a>
      </li>
      <li class="c-topics-pager__item">
        <a :href="'../#' + category.name" class="c-topics-pager__link" :class="{'-active': category}">
          ALL {{category.label}}
        </a>
      </li>
      <li class="c-topics-pager__item">
        <a :href="next" class="c-topics-pager__link" :class="{'-active': next}">
          <span>NEXT</span>
          <e-icon name="triangle-right"></e-icon>
        </a>
      </li>

    </ul>
  </div>
</template>

<script>

import categories from "../data/topics-categories.js";
import path from "path";
import u from "../lib/u";
import Icon from "../element/icon.vue";

export default {
  props: ["modifier"],

  components: {
    "e-icon": Icon
  },

  data (){
    return {
      state: false,
      list: null,
      prev: null,
      next: null,
      category: {
        name: null,
        label: null
      }
    }
  },

  mounted (){
    $.ajax({
      url: "../index.json"
    })
    .then(this.init);
  },

  methods: {
    init (data){
      let list = data.topics;
      /*
      // ソートをするのはやめる
      list.sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      });
      */

      // このページのインデックスを取得
      let index = null;
      let filename = path.basename(location.href);
      list.map((item, i) => {
        if(path.basename(item.href) === filename) {
          index = i;
          this.category = this.getCategory(item.category);
        }
      });

      // if(! /\-hidden/.test(this.modifier)){
      if(list.length > 2){
        this.next = u.exists(list[index-1], "href");
        this.prev = u.exists(list[index+1], "href");
      }

      this.state = true;
    },

    getCategory (name){
      let r = categories.filter((item) => {
        return item.name === name;
      });
      return r.length ? r[0] : null;
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/component/topics-pager.vue